import ProjectDonateForm from '../modules/forms/projects/donate';
import ProjectDonateConfirm from '../modules/components/projects/donate-confirm';

export default function setDonationScripts () {
    if (!window.location.pathname.includes('/donate/')) return;

    const path = window.location.pathname;

    const routes = {
        donate: () => path === '/donate/',
        confirm: () => path === '/donate/confirm/',
    };

    if (routes.donate()) {
        if (document.querySelector('#project-donation-form')) {
            new ProjectDonateForm('#project-donation-form');
        }
    }
    
    if (routes.confirm()) {
        new ProjectDonateConfirm();
    }
}
